import React from 'react';
import {WBPopupDirection} from './WBPopup';
import WBPopupTrigger, {TriggerGenerator} from './WBPopupTrigger';
import WBMenu, {WBMenuOption, WBMenuOnSelectHandler} from './WBMenu';
import makeComp from '../../util/profiler';

export interface WBPopupMenuTriggerProps {
  options: WBMenuOption[];
  selected?: number | string;
  direction?: WBPopupDirection;
  menuWidth?: number;
  menuBackgroundColor?: string;
  children: TriggerGenerator;
  onSelect?: WBMenuOnSelectHandler;
}

const WBPopupMenuTrigger: React.FC<WBPopupMenuTriggerProps> = makeComp(
  props => {
    return (
      <WBPopupTrigger
        direction={props.direction}
        triangleColor={props.menuBackgroundColor}
        popupContent={({close}) => (
          <WBMenu
            // classname just used to identify in testing
            className="wb-menu-trigger-content"
            width={props.menuWidth}
            options={props.options}
            selected={props.selected}
            onSelect={(val, extra) => {
              close();
              props.onSelect?.(val, extra);
            }}
            onEsc={close}
            backgroundColor={props.menuBackgroundColor}
          />
        )}>
        {props.children}
      </WBPopupTrigger>
    );
  },
  {id: 'WBPopupMenuTrigger'}
);

export default WBPopupMenuTrigger;
